/** Colour role of a pill — G1: colour only where it carries meaning. */
export type PillTone = 'neutral' | 'primary' | 'success' | 'info' | 'warning' | 'error' | 'violet';

/** Release status → tone (Unpublished primary, Live success, Discarded error). */
export function releaseStatusTone(status: string): PillTone {
  switch (status) {
    case 'DRAFT':
      return 'primary';
    case 'ACTIVE':
      return 'success';
    case 'DISCARDED':
      return 'error';
    default:
      return 'neutral';
  }
}

/** Value type → tone. */
export function valueTypeTone(type: string): PillTone {
  switch (type) {
    case 'ENUMERATED':
      return 'primary';
    case 'NUMERIC_WITH_UNIT':
      return 'warning';
    case 'BOOLEAN':
      return 'violet';
    default:
      return 'neutral';
  }
}

/** Confidence → tone. */
export function confidenceTone(c: string | null): PillTone {
  switch (c) {
    case 'HIGH':
      return 'success';
    case 'MEDIUM':
      return 'info';
    case 'LOW':
      return 'warning';
    default:
      return 'neutral';
  }
}

/** Change op → tone (added green, archived red, restored violet, the rest info). */
export function opTone(op: string): PillTone {
  switch (op) {
    case 'CREATE':
      return 'success';
    case 'ARCHIVE':
      return 'error';
    case 'RESTORE':
      return 'violet';
    default:
      return 'info';
  }
}
